import { GenericViewPresenterModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace GenericViewActions {
  export class FetchTransitoryViews {
    static readonly type = '[Generic Views] Fetch Transitory Views';
    constructor(
      public payload: {
        skip?: number;
        limit?: number;
        searchTerm?: string;
        filters?: { [key: string]: any };
        filterBy?: string[];
        viewIds?: string[];
      },
    ) {}
  }
  export class FetchGenericViewsReferences {
    static readonly type = '[Generic Views] Fetch Generic Views References';
    constructor(
      public payload: {
        filters?: { [key: string]: any };
        filterBy?: string[];
      },
    ) {}
  }

  export class FetchViews {
    static readonly type = '[Generic Views] Fetch Views';
    constructor(
      public payload: {
        skip?: number;
        limit?: number;
        searchTerm?: string;
        filters?: { [key: string]: any };
      },
    ) {}
  }

  export class FetchView {
    static readonly type = '[Generic Views] Fetch View';
    constructor(public viewId: string) {}
  }

  export class FetchViewForEndUser {
    static readonly type = '[Generic Views] Fetch View For End User';
    constructor(public viewId: string) {}
  }
  export class FetchViewForEndUserV2 {
    static readonly type = '[Generic Views V2] Fetch View For End User';
    constructor(public viewId: string) {}
  }

  export class SelectView {
    static readonly type = '[Generic Views] Select View';
    constructor(public viewId: string) {}
  }

  export class CreateView {
    static readonly type = '[Generic Views] Create View';
    constructor(public view: GenericViewPresenterModel) {}
  }

  export class UpdateView {
    static readonly type = '[Generic Views] Update View';
    constructor(
      public viewId: string,
      public view: GenericViewPresenterModel,
    ) {}
  }

  export class DeleteView {
    static readonly type = '[Generic Views] Delete View';
    constructor(public view: GenericViewPresenterModel) {}
  }

  export class GetCountsByTypes {
    static readonly type = '[Generic Views] get counts by permission scoop';
    constructor(
      public payload: {
        searchTerm?: string;
        filter?: { [key: string]: any };
      },
    ) {}
  }
  export class FetchDefaultPage {
    static readonly type = '[Generic Views]  Fetch Default Page';
  }
}
